import React from 'react';
import { useDispatch, useSelector } from "react-redux"
import { CSSTransition } from 'react-transition-group';
import { fetchSettings, showModal } from "./headerSlice"
import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { About } from "../../about/about";

import { ReactComponent as  PhoneIcon} from "../../../assets/images/icons/phone.svg";
import { ReactComponent as  SearchIcon}from "../../../assets/images/icons/search.svg";
import { ReactComponent as  AboutIcon} from "../../../assets/images/icons/about.svg";
import { ReactComponent as ArrowIcon } from "../../../assets/images/icons/arrow.svg";


import './header.css';

const Header = () => {
    const bgCompanyName = useSelector(state => state.header.about?.bgCompanyName) || '';
    const phone = useSelector(state => state.header.about?.phone) || null;
    const headerLoadingStatus = useSelector(state => state.header.headerLoadingStatus);
    const bg = useSelector(state => state.header.settings.banner);
    const showAbout = useSelector(state => state.header.aboutActive);
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const backHandle = () => {
        return navigate('/');
    }
    const isRootPath = pathname === '/';

    return (
        <>
            <header className={`position-relative ${!isRootPath && 'min'}`}>
                {isRootPath ? 
                    (
                        <>
                            <div className="banner">
                                <img src={bg} alt="" />
                            </div>
                            <nav className="pt-1 pe-2">
                                <div className="items">
                                    <Link to={`/search`} className="search-open me-2">
                                        <SearchIcon/>
                                    </Link>
                                    <div>
                                        <a href={`tel:${phone && phone}`}>
                                            <PhoneIcon/>
                                        </a>
                                    </div>
                                    <div onClick={() => dispatch(showModal(showAbout))}>
                                        <AboutIcon/>
                                        <span>Про нас</span>
                                    </div>
                                </div>
                            </nav>
                        </>
                    )

                    :

                    (
                        <div className='position-absolute top-50 start-0 translate-middle-y back' onClick={backHandle}>
                            <ArrowIcon/>
                            <span>Назад</span>
                        </div>
                    )
                }
                <div className="company-name">{bgCompanyName && bgCompanyName}</div>
            </header>
            <CSSTransition
                in={showAbout}
                timeout={300}
                classNames="modal"
                unmountOnExit
            >
                <About/>
            </CSSTransition>
        </>
    )
}

export default React.memo(Header);